import { useMutation } from '@tanstack/react-query';
import type { project } from '@/types';
import type { ScmProviderId } from '@/types/scm-provider';
import { scmPost } from './scmClient';

interface projectOrganization {
  authenticatedUser: {
    id: string;
    descriptor: string;
    subjectDescriptor: string;
    providerDisplayName: string;
    customDisplayName: string;
    isActive: boolean;
    properties: {
      Account: {
        $type: string;
        $value: string;
      };
    };
    resourceVersion: number;
    metaTypeId: number;
  };
  authorizedUser: {
    id: string;
    descriptor: string;
    subjectDescriptor: string;
    providerDisplayName: string;
    customDisplayName: string;
    isActive: boolean;
    properties: {
      Account: {
        $type: string;
        $value: string;
      };
    };
    resourceVersion: number;
    metaTypeId: number;
  };
  instanceId: string;
  deploymentId: string;
  deploymentType: string;
  locationServiceData: {
    serviceOwner: string;
    defaultAccessMappingMoniker: string;
    lastChangeId: number;
    lastChangeId64: number;
  };
}

interface ProjectRes {
  success: boolean;
  statusCode: number;
  message: string;
  data: {
    organization: projectOrganization;
    projects: {
      count: number;
      value: project[];
    };
  };
}

interface RequestBody {
  provider: ScmProviderId;
  body: {
    organization: string;
  };
  requesterToken: {
    patToken: string;
  };
}

export const getProjectsDetails = ({
  provider,
  body,
  requesterToken,
}: RequestBody): Promise<ProjectRes> => {
  return scmPost(provider, '/api/scm/projects', requesterToken.patToken, body);
};

export const useProjectDetail = ({ provider, body, requesterToken }: RequestBody) => {
  const res = useMutation({
    mutationFn: () => getProjectsDetails({ provider, body, requesterToken }),
  });
  return {
    proData: res.data,
    proPending: res.isPending,
    proError: res.error,
    proStatus: res.status,
    mutate: res.mutate,
  };
};
